import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  error: null,
  data: {
    invoiceCard: {
      invoices: { freightInvoice: [], proformaInvoice: [], taxInvoice: [] }
    },
    config: {}
  },
  dataValidationDetails: {
    loading: false,
    data: {}
  },
  serviceHistoryDetails: {
    loading: false,
    data: {}
  },
  warrantyDetails: {
    loading: false,
    updatingLoading: false,
    data: {}
  },
  holdsDetails: {
    loading: false,
    addHoldsLoading: false,
    inActiveHoldsLoading: false,
    data: [],
    inActiveHoldsData: []
  },
  pricingDetails: {
    loading: false,
    data: {},
    pricingModalDetails: {
      modalLoading: false,
      data: {}
    }
  },
  publishingChecklist: {
    loading: false,
    data: {}
  },
  currentCardStep: null,
  appointmentId: null,
  marketplace: {
    loading: false,
    data: {}
  },
  recall: {
    loading: false,
    data: {}
  },
  review: {
    loading: false,
    reviewDetails: {}
  },
  soldQCDetails: {
    loading: false,
    error: false,
    data: null
  },
  videographyPrompt: {
    loading: false,
    updatingLoading: false,
    prompt: null,
    error: false
  },
  videographyPremiumFeaturesTag: {
    loading: false,
    data: {}
  },
  videographyWorkstation: {
    loading: false,
    updating: false,
    error: null,
    data: null
  },
  videographyProcessTracker: {
    loading: false,
    error: null,
    data: null,
    currentAudio: null
  },
  videographyFinalVideo: {
    loading: false,
    updating: false,
    error: null,
    data: null
  },
  videographyFinalVideoPlatform: {
    loading: false,
    status: null,
    error: null
  },
  videographyModal: {
    confirmModal: {
      isOpen: false,
      type: null,
      isLoading: false,
      handleSubmit: () => {}
    },
    uploadModal: {
      isUploadSuccess: false,
      isOpen: false,
      type: null,
      uploadCustomFileName: null,
      fileUploadSubType: null,
      handleFileUpload: () => {}
    }
  },
  paymentDetails: {
    loading: false,
    error: false,
    paymentTrackerDetails: {
      columns: [],
      dataSource: [],
      total: 0,
      statusList: []
    }
  }
};

const fetchSummaryStart = (state) => ({
  ...state,
  data: {},
  error: null,
  loading: true
});

const fetchSummarySuccess = (state, action) => ({
  ...state,
  data: action.data,
  error: null,
  loading: false
});

const fetchSummaryFail = (state, action) => ({
  ...state,
  data: {},
  error: action.error,
  loading: false
});

const updateRefurbEstimateDate = (state, action) => ({
  ...state,
  data: {
    ...state.data,
    refurbEstimateDate: action.refurbEstimateDate,
    vehicleInfo: {
      ...(state.data?.vehicleInfo || {}),
      refurbEstimateDate: action.refurbEstimateDate
    }
  }
});

const setCurrentCardStep = (state, action) => ({
  ...state,
  currentCardStep: action.step
});

const fetchDataValidationStart = (state) => ({
  ...state,
  dataValidationDetails: {
    loading: true
  }
});

const fetchDataValidationSuccess = (state, action) => ({
  ...state,
  dataValidationDetails: {
    loading: false,
    data: action.data
  }
});

const fetchDataValidationFail = (state) => ({
  ...state,
  dataValidationDetails: {
    loading: false
  }
});

const postDataValidationStart = (state) => ({
  ...state
});

const postDataValidationFail = (state) => ({
  ...state,
  dataValidationDetails: {
    loading: false
  }
});

const serviceHistoryDetails = (state) => ({
  ...state,
  dataValidationDetails: {
    loading: true
  }
});

const getServiceHistorySuccess = (state, action) => ({
  ...state,
  serviceHistoryDetails: {
    loading: false,
    data: action.data
  }
});

const getServiceHistoryFail = (state) => ({
  ...state,
  serviceHistoryDetails: {
    loading: false
  }
});

const fetchWarrantyStart = (state) => ({
  ...state,
  warrantyDetails: {
    ...state.warrantyDetails,
    loading: true,

    data: {}
  }
});
const fetchWarrantySuccess = (state, action) => ({
  ...state,
  warrantyDetails: {
    ...state.warrantyDetails,
    loading: false,
    data: action.data
  }
});
const fetchWarrantyFail = (state) => ({
  ...state,
  warrantyDetails: {
    ...state.warrantyDetails,
    loading: false,
    data: {}
  }
});

const postWarrantyStart = (state) => ({
  ...state,
  warrantyDetails: {
    ...state.warrantyDetails,
    updatingLoading: true
  }
});
const postWarrantySuccess = (state) => ({
  ...state,
  warrantyDetails: {
    ...state.warrantyDetails,
    updatingLoading: false
  }
});
const postWarrantyFail = (state) => ({
  ...state,
  warrantyDetails: {
    ...state.warrantyDetails,
    updatingLoading: false
  }
});

const fetchHoldsStart = (state) => ({
  ...state,
  holdsDetails: {
    ...state.holdsDetails,
    loading: true
  }
});
const fetchHoldsSuccess = (state, action) => ({
  ...state,
  holdsDetails: {
    ...state.holdsDetails,
    data: action.data,
    loading: false
  }
});
const fetchHoldsFail = (state) => ({
  ...state,
  holdsDetails: {
    ...state.holdsDetails,
    loading: false
  }
});

const fetchInActiveHoldsStart = (state) => ({
  ...state,
  holdsDetails: {
    ...state.holdsDetails,
    inActiveHoldsLoading: true
  }
});
const fetchInActiveHoldsSuccess = (state, action) => ({
  ...state,
  holdsDetails: {
    ...state.holdsDetails,
    inActiveHoldsData: action.data,
    inActiveHoldsLoading: false
  }
});
const fetchInActiveHoldsFail = (state) => ({
  ...state,
  holdsDetails: {
    ...state.holdsDetails,
    inActiveHoldsLoading: false
  }
});

const addHoldsStart = (state) => ({
  ...state,
  holdsDetails: {
    ...state.holdsDetails,
    addHoldsLoading: true
  }
});
const addHoldsSuccess = (state) => ({
  ...state,
  holdsDetails: {
    ...state.holdsDetails,
    addHoldsLoading: false
  }
});
const addHoldsFail = (state) => ({
  ...state,
  holdsDetails: {
    ...state.holdsDetails,
    addHoldsLoading: false
  }
});

const fetchPricingStart = (state) => ({
  ...state,
  pricingDetails: {
    ...state.pricingDetails,
    loading: true
  }
});
const fetchPricingSuccess = (state, action) => ({
  ...state,
  pricingDetails: {
    ...state.pricingDetails,
    loading: false,
    data: action.data
  }
});
const fetchPricingFail = (state) => ({
  ...state,
  pricingDetails: {
    ...state.pricingDetails,
    loading: false
  }
});

const fetchPricingModalStart = (state) => ({
  ...state,
  pricingDetails: {
    ...state.pricingDetails,
    pricingModalDetails: {
      modalLoading: true
    }
  }
});
const fetchPricingModalSuccess = (state, action) => ({
  ...state,
  pricingDetails: {
    ...state.pricingDetails,
    pricingModalDetails: {
      modalLoading: false,
      data: action.data
    }
  }
});
const fetchPricingModalFail = (state) => ({
  ...state,
  pricingDetails: {
    ...state.pricingDetails,
    pricingModalDetails: {
      modalLoading: false,
      data: {}
    }
  }
});

const getCheckListStart = (state) => ({
  ...state,
  publishingChecklist: {
    loading: true,
    data: {}
  }
});

const getCheckListSuccess = (state, action) => ({
  ...state,
  publishingChecklist: {
    loading: false,
    data: action.data
  }
});

const getCheckListFail = (state) => ({
  ...state,
  publishingChecklist: {
    loading: false,
    data: {}
  }
});

const getMarketplaceStart = (state) => ({
  ...state,
  marketplace: {
    loading: true,
    data: {}
  }
});

const getMarketplaceSuccess = (state, action) => ({
  ...state,
  marketplace: {
    loading: false,
    data: action.data
  }
});

const getMarketplaceFail = (state) => ({
  ...state,
  marketplace: {
    loading: false
  }
});

const fetchRecallTabStart = (state) => ({
  ...state,
  recall: {
    loading: true,
    data: {}
  }
});

const fetchRecallTabSuccess = (state, action) => ({
  ...state,
  recall: {
    loading: false,
    data: action.data
  }
});

const fetchRecallTabFail = (state) => ({
  ...state,
  recall: {
    loading: false,
    ...state.recall
  }
});

const fetchReviewTabStart = (state) => ({
  ...state,
  review: {
    loading: true,
    reviewDetails: {}
  }
});

const fetchReviewTabSuccess = (state, action) => ({
  ...state,
  review: {
    loading: false,
    reviewDetails: action.data
  }
});

const fetchReviewTabFail = (state) => ({
  ...state,
  review: {
    ...state.review,
    loading: false
  }
});

const fetchSoldQCDetailStart = (state) => ({
  ...state,
  soldQCDetails: {
    loading: true,
    error: false,
    data: null
  }
});

const fetchSoldQCDetailSuccess = (state, action) => ({
  ...state,
  soldQCDetails: {
    loading: false,
    error: false,
    data: action.data
  }
});

const fetchSoldQCDetailFail = (state) => ({
  ...state,
  soldQCDetails: {
    loading: false,
    error: true,
    data: null
  }
});

const fetchVideographyPremiumFeaturesTagStart = (state) => ({
  ...state,
  videographyPremiumFeaturesTag: {
    loading: true,
    data: {}
  }
});

const fetchVideographyPremiumFeaturesTagSuccess = (state, action) => ({
  ...state,
  videographyPremiumFeaturesTag: {
    loading: false,
    data: action.data
  }
});

const fetchVideographyPremiumFeaturesTagFail = (state) => ({
  ...state,
  videographyPremiumFeaturesTag: {
    loading: false,
    data: {}
  }
});

const fetchVideographyPromptStart = (state) => ({
  ...state,
  videographyPrompt: {
    loading: true,
    error: false,
    prompt: null
  }
});

const fetchVideographyPromptSuccess = (state, action) => ({
  ...state,
  videographyPrompt: {
    loading: false,
    error: false,
    prompt: action.data.prompt
  }
});

const fetchVideographyPromptFail = (state) => ({
  ...state,
  videographyPrompt: {
    ...state.videographyPrompt,
    loading: false,
    error: true,
    prompt: null
  }
});

const updateVideographyPromptStart = (state) => ({
  ...state,
  videographyPrompt: {
    ...state.videographyPrompt,
    updatingLoading: true
  }
});

const updateVideographyPromptSuccess = (state, action) => ({
  ...state,
  videographyPrompt: {
    ...state.videographyPrompt,
    updatingLoading: false,
    prompt: action.data.prompt
  }
});

const updateVideographyPromptFail = (state) => ({
  ...state,
  videographyPrompt: {
    ...state.videographyPrompt,
    updatingLoading: false
  }
});

const fetchVideographyWorkstationDetailsStart = (state) => ({
  ...state,
  videographyWorkstation: {
    ...state.videographyWorkstation,
    loading: true,
    error: false
  }
});

const fetchVideographyWorkstationDetailsSuccess = (state, action) => ({
  ...state,
  videographyWorkstation: {
    ...state.videographyWorkstation,
    loading: false,
    data: action.data,
    error: false
  }
});

const fetchVideographyWorkstationDetailsFailure = (state) => ({
  ...state,
  videographyWorkstation: {
    ...state.videographyWorkstation,
    loading: false,
    error: true,
    data: null
  }
});

const setVideographyQcActionType = (state, action) => ({
  ...state,
  videographyWorkstation: {
    ...state.videographyWorkstation,
    updating: false,
    error: false,
    actionType: action.data
  }
});

const fetchProcessTrackerDetailsStart = (state) => ({
  ...state,
  videographyProcessTracker: {
    ...state.videographyProcessTracker,
    loading: true,
    error: false
  }
});

const fetchProcessTrackerDetailsSuccess = (state, action) => ({
  ...state,
  videographyProcessTracker: {
    ...state.videographyProcessTracker,
    data: action.data,
    loading: false,
    error: false
  }
});

const fetchProcessTrackerDetailsFailure = (state) => ({
  ...state,
  videographyProcessTracker: {
    ...state.videographyProcessTracker,
    loading: false,
    error: true
  }
});

const setAudioNodeProcessTracker = (state, action) => ({
  ...state,
  videographyProcessTracker: {
    ...state.videographyProcessTracker,
    loading: false,
    error: true,
    currentAudio: action.currentAudio
  }
});

const resetPocessTrackerDetails = (state) => ({
  ...state,
  videographyProcessTracker: {
    ...state.videographyProcessTracker,
    data: null,
    loading: false,
    error: false,
    currrentAudio: null
  }
});

const completeVideographyQcActionStart = (state) => ({
  ...state,
  videographyWorkstation: {
    ...state.videographyWorkstation,
    updating: true,
    error: false
  }
});

const completeVideographyQcActionSuccess = (state, action) => ({
  ...state,
  videographyWorkstation: {
    ...state.videographyWorkstation,
    updating: false,
    data: action.data,
    error: false
  }
});

const completeVideographyQcActionFailure = (state) => ({
  ...state,
  videographyWorkstation: {
    ...state.videographyWorkstation,
    updating: false,
    error: true
  }
});

const updateVideographyWorkstationDataStart = (state) => ({
  ...state,
  videographyWorkstation: {
    ...state.videographyWorkstation,
    updating: true,
    error: false
  }
});

const updateVideographyWorkstationDataSuccess = (state, action) => ({
  ...state,
  videographyWorkstation: {
    ...state.videographyWorkstation,
    updating: false,
    data: action.data,
    error: false
  }
});

const updateVideographyWorkstationDataFailure = (state, action) => ({
  ...state,
  videographyWorkstation: {
    ...state.videographyWorkstation,
    updating: false,
    error: true
  }
});

const resetFinalVideoExtraction = (state) => ({
  ...state,
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: false,
    status: null,
    error: null
  }
});

const resetFinalVideoDetails = (state) => ({
  ...state,
  videographyFinalVideo: {
    ...state.videographyFinalVideo,
    loading: false,
    error: false,
    data: null
  },
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: false,
    status: null,
    error: null
  }
});

const fetchVideographyFinalVideoDetailsStart = (state) => ({
  ...state,
  videographyFinalVideo: {
    ...state.videographyFinalVideo,
    loading: true,
    error: false
  }
});

const fetchVideographyFinalVideoDetailsSuccess = (state, action) => ({
  ...state,
  videographyFinalVideo: {
    ...state.videographyFinalVideo,
    loading: false,
    data: action.data,
    error: false
  }
});

const fetchVideographyFinalVideoDetailsFailure = (state) => ({
  ...state,
  videographyFinalVideo: {
    ...state.videographyFinalVideo,
    loading: false,
    error: true,
    data: null
  }
});

const updateVideographyFinalVideoDetailsStart = (state) => ({
  ...state,
  videographyFinalVideo: {
    ...state.videographyFinalVideo,
    updating: true,
    error: false
  }
});

const updateVideographyFinalVideoDetailsSuccess = (state, action) => ({
  ...state,
  videographyFinalVideo: {
    ...state.videographyFinalVideo,
    updating: false,
    data: action.data,
    error: false
  }
});

const updateVideographyFinalVideoDetailsFailure = (state) => ({
  ...state,
  videographyFinalVideo: {
    ...state.videographyFinalVideo,
    updating: false,
    error: true
  }
});

const generateFinalVideoChapterGifStart = (state) => ({
  ...state,
  videographyFinalVideo: {
    ...state.videographyFinalVideo,
    loading: true,
    error: false
  }
});

const generateFinalVideoChapterGifSuccess = (state, action) => ({
  ...state,
  videographyFinalVideo: {
    ...state.videographyFinalVideo,
    loading: false,
    data: action.data,
    error: false
  }
});

const generateFinalVideoChapterGifFailure = (state) => ({
  ...state,
  videographyFinalVideo: {
    ...state.videographyFinalVideo,
    loading: false,
    error: true
  }
});

const uploadFinalVideoPlatformStart = (state) => ({
  ...state,
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: true,
    error: false
  }
});

const uploadFinalVideoPlatformSuccess = (state, action) => ({
  ...state,
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: false,
    status: action.data,
    error: false
  }
});

const uploadFinalVideoPlatformFailure = (state) => ({
  ...state,
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: false,
    error: true
  }
});

const checkFinalVideoPlatformStatusStart = (state) => ({
  ...state,
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: true,
    error: false
  }
});

const checkFinalVideoPlatformStatusSuccess = (state, action) => ({
  ...state,
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: false,
    status: action.data,
    error: false
  }
});

const checkFinalVideoPlatformStatusFailure = (state) => ({
  ...state,
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: false,
    error: true
  }
});

const publishFinalVideoStart = (state) => ({
  ...state,
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: true,
    error: false
  }
});

const publishFinalVideoSuccess = (state, action) => ({
  ...state,
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: false,
    status: action.data,
    error: false
  }
});

const publishFinalVideoFailure = (state) => ({
  ...state,
  videographyFinalVideoPlatform: {
    ...state.videographyFinalVideoPlatform,
    loading: false,
    error: true
  }
});

const toggleVideographyConfirmModal = (state, action) => ({
  ...state,
  videographyModal: {
    ...state.videographyModal,
    confirmModal: {
      ...state.videographyModal.confirmModal,
      isOpen: action.isOpen
    }
  }
});

const setVideographyConfirmModal = (state, action) => ({
  ...state,
  videographyModal: {
    ...state.videographyModal,
    confirmModal: {
      ...state.videographyModal.confirmModal,
      type: action.data.type,
      handleSubmit: action.data.handleSubmit
    }
  }
});

const toggleVideographyConfirmModalLoading = (state, action) => ({
  ...state,
  videographyModal: {
    ...state.videographyModal,
    confirmModal: {
      ...state.videographyModal.confirmModal,
      isLoading: action.isLoading
    }
  }
});
const toggleVideographyUploadModal = (state, action) => ({
  ...state,
  videographyModal: {
    ...state.videographyModal,
    uploadModal: {
      ...state.videographyModal.uploadModal,
      isOpen: action.isOpen
    }
  }
});

const setVideographyUploadModal = (state, action) => ({
  ...state,
  videographyModal: {
    ...state.videographyModal,
    uploadModal: {
      ...state.videographyModal.uploadModal,
      type: action.data.type,
      uploadCustomFileName: action.data.uploadCustomFileName,
      fileUploadSubType: action.data.fileUploadSubType,
      handleFileUpload: action.data.handleFileUpload
    }
  }
});

const setVideographyUploadStatus = (state, action) => ({
  ...state,
  videographyModal: {
    ...state.videographyModal,
    uploadModal: {
      ...state.videographyModal.uploadModal,
      isUploadSuccess: action.isUploadSuccess
    }
  }
});

const fetchPaymentDetailsStart = (state) => ({
  ...state,
  paymentDetails: {
    loading: false,
    error: false,
    paymentTrackerDetails: {
      columns: [],
      dataSource: [],
      paymentDetails: null
    }
  }
});

const fetchPaymentDetailsSuccess = (state, action) => {
  const { columns = [], paymentTrackerDto } = action.data;
  const { paymentTrackers: dataSource } = paymentTrackerDto || {};

  return {
    ...state,
    paymentDetails: {
      loading: false,
      error: false,
      paymentTrackerDetails: {
        columns,
        dataSource,
        paymentDetails: { ...paymentTrackerDto }
      }
    }
  };
};

const fetchPaymentDetailsFail = (state) => ({
  ...state,
  paymentDetails: {
    paymentTrackerDetails: {
      ...state.paymentDetails?.paymentTrackerDetails
    },
    loading: false,
    error: true
  }
});

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SUMMARY_START:
      return fetchSummaryStart(state, action);

    case actionTypes.FETCH_SUMMARY_SUCCESS:
      return fetchSummarySuccess(state, action);

    case actionTypes.FETCH_SUMMARY_FAIL:
      return fetchSummaryFail(state, action);

    case actionTypes.UPDATE_REFURB_ESTIMATE_DATE:
      return updateRefurbEstimateDate(state, action);

    case actionTypes.SET_CURRENT_CARD_STEP:
      return setCurrentCardStep(state, action);

    case actionTypes.FETCH_DATA_VALIDATION_START:
      return fetchDataValidationStart(state, action);

    case actionTypes.FETCH_DATA_VALIDATION_SUCCESS:
      return fetchDataValidationSuccess(state, action);

    case actionTypes.FETCH_DATA_VALIDATION_FAIL:
      return fetchDataValidationFail(state, action);

    case actionTypes.POST_DATA_VALIDATION_START:
      return postDataValidationStart(state, action);

    case actionTypes.POST_DATA_VALIDATION_FAIL:
      return postDataValidationFail(state, action);

    case actionTypes.FETCH_SERVICE_HISTORY_START:
      return serviceHistoryDetails(state, action);

    case actionTypes.FETCH_SERVICE_HISTORY_SUCCESS:
      return getServiceHistorySuccess(state, action);

    case actionTypes.FETCH_SERVICE_HISTORY_FAIL:
      return getServiceHistoryFail(state, action);

    case actionTypes.FETCH_WARRANTY_START:
      return fetchWarrantyStart(state);

    case actionTypes.FETCH_WARRANTY_SUCCESS:
      return fetchWarrantySuccess(state, action);

    case actionTypes.FETCH_WARRANTY_FAIL:
      return fetchWarrantyFail(state);

    case actionTypes.POST_WARRANTY_START:
      return postWarrantyStart(state);

    case actionTypes.POST_WARRANTY_SUCCESS:
      return postWarrantySuccess(state, action);

    case actionTypes.POST_WARRANTY_FAIL:
      return postWarrantyFail(state);

    case actionTypes.FETCH_HOLDS_START:
      return fetchHoldsStart(state);

    case actionTypes.FETCH_HOLDS_SUCCESS:
      return fetchHoldsSuccess(state, action);

    case actionTypes.FETCH_HOLDS_FAIL:
      return fetchHoldsFail(state);

    case actionTypes.FETCH_PRICING_START:
      return fetchPricingStart(state);

    case actionTypes.FETCH_PRICING_SUCCESS:
      return fetchPricingSuccess(state, action);

    case actionTypes.FETCH_PRICING_FAIL:
      return fetchPricingFail(state);

    case actionTypes.FETCH_PRICING_MODAL_START:
      return fetchPricingModalStart(state);

    case actionTypes.FETCH_PRICING_MODAL_SUCCESS:
      return fetchPricingModalSuccess(state, action);

    case actionTypes.FETCH_PRICING_MODAL_FAIL:
      return fetchPricingModalFail(state);

    case actionTypes.FETCH_INACTIVE_HOLDS_START:
      return fetchInActiveHoldsStart(state);

    case actionTypes.FETCH_INACTIVE_HOLDS_SUCCESS:
      return fetchInActiveHoldsSuccess(state, action);

    case actionTypes.FETCH_INACTIVE_HOLDS_FAIL:
      return fetchInActiveHoldsFail(state);

    case actionTypes.ADD_HOLDS_START:
      return addHoldsStart(state);

    case actionTypes.ADD_HOLDS_SUCCESS:
      return addHoldsSuccess(state, action);

    case actionTypes.ADD_HOLDS_FAIL:
      return addHoldsFail(state);

    case actionTypes.FETCH_PUBLISHING_CHECKLIST_START:
      return getCheckListStart(state);

    case actionTypes.FETCH_PUBLISHING_CHECKLIST_SUCCESS:
      return getCheckListSuccess(state, action);

    case actionTypes.FETCH_PUBLISHING_CHECKLIST_FAIL:
      return getCheckListFail(state);

    case actionTypes.FETCH_MARKETPLACE_START:
      return getMarketplaceStart(state);

    case actionTypes.FETCH_MARKETPLACE_SUCCESS:
      return getMarketplaceSuccess(state, action);

    case actionTypes.FETCH_MARKETPLACE_FAIL:
      return getMarketplaceFail(state);

    case actionTypes.FETCH_RECALL_TAB_START:
      return fetchRecallTabStart(state);

    case actionTypes.FETCH_RECALL_TAB_SUCCESS:
      return fetchRecallTabSuccess(state, action);

    case actionTypes.FETCH_RECALL_TAB_FAIL:
      return fetchRecallTabFail(state);

    case actionTypes.FETCH_REVIEW_TAB_DETAILS_START:
      return fetchReviewTabStart(state);

    case actionTypes.FETCH_REVIEW_TAB_DETAILS_SUCCESS:
      return fetchReviewTabSuccess(state, action);

    case actionTypes.FETCH_REVIEW_TAB_DETAILS_FAIL:
      return fetchReviewTabFail(state);
    case actionTypes.FETCH_SOLD_QC_DETAILS_REQUEST:
      return fetchSoldQCDetailStart(state);

    case actionTypes.FETCH_SOLD_QC_DETAILS_SUCCESS:
      return fetchSoldQCDetailSuccess(state, action);

    case actionTypes.FETCH_SOLD_QC_DETAILS_FAILURE:
      return fetchSoldQCDetailFail(state);

    case actionTypes.FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_REQUEST:
      return fetchVideographyPremiumFeaturesTagStart(state);

    case actionTypes.FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_SUCCESS:
      return fetchVideographyPremiumFeaturesTagSuccess(state, action);

    case actionTypes.FETCH_VIDEOGRAPHY_PREMIUM_FEATURES_TAG_FAILURE:
      return fetchVideographyPremiumFeaturesTagFail(state);

    case actionTypes.FETCH_VIDEOGRAPHY_PROMPT_REQUEST:
      return fetchVideographyPromptStart(state);

    case actionTypes.FETCH_VIDEOGRAPHY_PROMPT_SUCCESS:
      return fetchVideographyPromptSuccess(state, action);

    case actionTypes.FETCH_VIDEOGRAPHY_PROMPT_FAILURE:
      return fetchVideographyPromptFail(state);

    case actionTypes.UPDATE_VIDEOGRAPHY_PROMPT_REQUEST:
      return updateVideographyPromptStart(state);

    case actionTypes.UPDATE_VIDEOGRAPHY_PROMPT_SUCCESS:
      return updateVideographyPromptSuccess(state, action);

    case actionTypes.UPDATE_VIDEOGRAPHY_PROMPT_FAILURE:
      return updateVideographyPromptFail(state);

    case actionTypes.FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_REQUEST:
      return fetchVideographyWorkstationDetailsStart(state);

    case actionTypes.FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_SUCCESS:
      return fetchVideographyWorkstationDetailsSuccess(state, action);

    case actionTypes.FETCH_VIDEOGRAPHY_WORKSTATION_DETAILS_FAILURE:
      return fetchVideographyWorkstationDetailsFailure(state, action);

    case actionTypes.SET_VIDEOGRAPHY_QC_ACTION_TYPE:
      return setVideographyQcActionType(state, action);

    case actionTypes.FETCH_PROCESS_TRACKER_DETAILS_REQUEST:
      return fetchProcessTrackerDetailsStart(state);

    case actionTypes.FETCH_PROCESS_TRACKER_DETAILS_SUCCESS:
      return fetchProcessTrackerDetailsSuccess(state, action);

    case actionTypes.FETCH_PROCESS_TRACKER_DETAILS_FAILURE:
      return fetchProcessTrackerDetailsFailure(state);

    case actionTypes.SET_AUDIO_NODE_PROCESS_TRACKER:
      return setAudioNodeProcessTracker(state, action);

    case actionTypes.RESET_PROCESS_TRACKER_DETAILS:
      return resetPocessTrackerDetails(state);

    case actionTypes.COMPLETE_VIDEOGRAPHY_QC_ACTION_REQUEST:
      return completeVideographyQcActionStart(state);

    case actionTypes.COMPLETE_VIDEOGRAPHY_QC_ACTION_SUCCESS:
      return completeVideographyQcActionSuccess(state, action);

    case actionTypes.COMPLETE_VIDEOGRAPHY_QC_ACTION_FAILURE:
      return completeVideographyQcActionFailure(state, action);

    case actionTypes.UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_REQUEST:
      return updateVideographyWorkstationDataStart(state);

    case actionTypes.UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_SUCCESS:
      return updateVideographyWorkstationDataSuccess(state, action);

    case actionTypes.UPDATE_VIDEOGRAPHY_WORKSTATION_DATA_FAILURE:
      return updateVideographyWorkstationDataFailure(state, action);

    case actionTypes.FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_REQUEST:
      return fetchVideographyFinalVideoDetailsStart(state);

    case actionTypes.FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_SUCCESS:
      return fetchVideographyFinalVideoDetailsSuccess(state, action);

    case actionTypes.FETCH_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_FAILURE:
      return fetchVideographyFinalVideoDetailsFailure(state, action);

    case actionTypes.RESET_FINAL_VIDEO_DETAILS:
      return resetFinalVideoDetails(state);

    case actionTypes.RESET_FINAL_VIDEO_EXTRACTION:
      return resetFinalVideoExtraction(state);

    case actionTypes.TOGGLE_VIDEOGRAPHY_CONFIRM_MODAL:
      return toggleVideographyConfirmModal(state, action);

    case actionTypes.TOGGLE_VIDEOGRAPHY_UPLOAD_MODAL:
      return toggleVideographyUploadModal(state, action);

    case actionTypes.SET_VIDEOGRAPHY_CONFIRM_MODAL:
      return setVideographyConfirmModal(state, action);

    case actionTypes.TOGGLE_VIDEOGRAPHY_CONFIRM_MODAL_LOADING:
      return toggleVideographyConfirmModalLoading(state, action);

    case actionTypes.SET_VIDEOGRAPHY_UPLOAD_MODAL:
      return setVideographyUploadModal(state, action);

    case actionTypes.UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_REQUEST:
      return updateVideographyFinalVideoDetailsStart(state);

    case actionTypes.UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_SUCCESS:
      return updateVideographyFinalVideoDetailsSuccess(state, action);

    case actionTypes.UPDATE_VIDEOGRAPHY_FINAL_VIDEO_DETAILS_FAILURE:
      return updateVideographyFinalVideoDetailsFailure(state);

    case actionTypes.UPLOAD_FINAL_VIDEO_PLATFORM_REQUEST:
      return uploadFinalVideoPlatformStart(state);

    case actionTypes.UPLOAD_FINAL_VIDEO_PLATFORM_SUCCESS:
      return uploadFinalVideoPlatformSuccess(state, action);

    case actionTypes.UPLOAD_FINAL_VIDEO_PLATFORM_FAILURE:
      return uploadFinalVideoPlatformFailure(state);

    case actionTypes.GENERATE_FINAL_VIDEO_CHAPTER_GIF_REQUEST:
      return generateFinalVideoChapterGifStart(state);

    case actionTypes.GENERATE_FINAL_VIDEO_CHAPTER_GIF_SUCCESS:
      return generateFinalVideoChapterGifSuccess(state, action);

    case actionTypes.GENERATE_FINAL_VIDEO_CHAPTER_GIF_FAILURE:
      return generateFinalVideoChapterGifFailure(state);

    case actionTypes.CHECK_FINAL_VIDEO_PLATFORM_STATUS_REQUEST:
      return checkFinalVideoPlatformStatusStart(state);

    case actionTypes.CHECK_FINAL_VIDEO_PLATFORM_STATUS_SUCCESS:
      return checkFinalVideoPlatformStatusSuccess(state, action);

    case actionTypes.CHECK_FINAL_VIDEO_PLATFORM_STATUS_FAILURE:
      return checkFinalVideoPlatformStatusFailure(state);

    case actionTypes.PUBLISH_FINAL_VIDEO_REQUEST:
      return publishFinalVideoStart(state);

    case actionTypes.PUBLISH_FINAL_VIDEO_SUCCESS:
      return publishFinalVideoSuccess(state, action);

    case actionTypes.PUBLISH_FINAL_VIDEO_FAILURE:
      return publishFinalVideoFailure(state);

    case actionTypes.SET_VIDEOGRAPHY_UPLOAD_STATUS:
      return setVideographyUploadStatus(state, action);

    case actionTypes.FETCH_PAYMENT_DETAILS_START:
      return fetchPaymentDetailsStart(state);

    case actionTypes.FETCH_PAYMENT_DETAILS_SUCCESS:
      return fetchPaymentDetailsSuccess(state, action);

    case actionTypes.FETCH_PAYMENT_DETAILS_FAIL:
      return fetchPaymentDetailsFail(state);

    default:
      return state;
  }
};

export default reducer;
